export async function readFileToString(file: File): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      if (!e.target) {
        reject("FileReader target was null");
        return;
      }
      const fileData = e.target.result;
      if (typeof fileData === "string") {
        resolve(fileData);
      } else {
        reject(`Expected string; got ${typeof fileData}`);
      }
    };
    reader.onerror = async (e) => {
      reject(e);
    };
    reader.readAsText(file);
  });
}
